import React from 'react';
import { Loader } from "semantic-ui-react";
import Icon from '../../../../ui/icon/icon';
import { classnames } from '../../../../../../utils/classnames';
import PropTypes from 'prop-types';
import './itemCardActionButton.css';

export default function ItemCardActionButton({ as = null, label = null, icon, type = 'primary', onlyIcon = false, onClick = () => {}, isLoading = false, className = '', disabled = false, ...rest }) {
	const Component = as || 'button';
	const _onClick = React.useCallback((e) => {
		e.stopPropagation();

		if (disabled || isLoading) {
			return null;
		}
		onClick();
	}, [disabled, onClick, isLoading]);

	return (
		<div className={classnames('neo-action-button-wrapper')}>
			<Loader size="mini" active={isLoading} />
			<Component
				className={classnames('neo-action-button', type, className, {
					'disabled': disabled || isLoading,
					'only-icon': onlyIcon
				})}
				onClick={_onClick}
				aria-disabled={disabled}
				{...rest}
			>
				<div className={classnames('neo-action-button-label-and-icon', {'disabled': disabled || isLoading})}>
					{icon && <div className={classnames('neo-action-button-icon', {'without-icon': isLoading && onlyIcon})}>
						<Icon name={icon}/>
					</div>}
					<div className={classnames('neo-action-button-label', {'only-icon': onlyIcon})}>{label}</div>
				</div>
			</Component>
		</div>
	);
}

ItemCardActionButton.defaultProps = {
    as: null,
    label: null,
	icon: null,
    type: 'primary',
    onlyIcon: false,
	onClick: () => {},
	isLoading: false,
	className: '',
	disabled: false
}

ItemCardActionButton.propTypes = {
    as: PropTypes.any,
    label: PropTypes.string,
    icon: PropTypes.string,
    type: PropTypes.oneOf(['primary', 'inverted', 'confirm', 'delete']),
    onlyIcon: PropTypes.bool,
    onClick: PropTypes.func,
    isLoading: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool
};